module.exports = __webpack_public_path__ + "img/TaxAddress2.7fbff895.jpg";